import { getTypeCommon } from '@/api/leaflet.api'
const state = {
	sceneType: [],
	webData: [{
		name: 'PC落地页',
		code: 'PC',
		act: false,
		disabled: false,
		noClose:true
	}, {
		name: '手机落地页',
		code: '手机',
		act: false,
		disabled: false,
		noClose: true
	}
	],
}
const getters = {}
const mutations = {
	SET_SCENE_TYPE(state, data) {
		state.sceneType = data
	},
	MODIFY_WEB_DATA(state, data) {
		return state.webData.map(item => {
			item.disabled = item.code !== data
			return item
		})
	}
}
const actions = {
	async getTypeCommon({state, commit}) {
		if(state.sceneType.length > 0) return
		let { data } = await getTypeCommon({ typeName: '使用场景'})
		if(data.isSuccess) {
			let mapData = data.data.map(item => {
				return {...item, act: false, code: item.typeName, name: item.typeName}
			})
			commit('SET_SCENE_TYPE', mapData)
		}
	}
}

export default { state, getters, mutations, actions, namespaced: true}
